/* bf26y-r10b.js (13 Oct 2026): display-only follow-ups to r10.
   r17 (13 Oct): glove and sock pack selector order is Single, 3 Pack, 2 Pack, then the rest (inputs and labels move together, checked state untouched), and the 3 Pack gets a "+free wash bag" note (r54 wording; hidden on product pages by bf26y-r52.css, which prints its own). Backup: bf26y-r10b-bak-20261013-r17.js */
(function () {
  'use strict';
  function rkLazy(fn, own) { var go = function () { if (window.BF26 && BF26.lazy) BF26.lazy(fn); else own(); }; if ((window.BF26 && BF26.lazy) || document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go); } /* 21 Oct 2026: shared sweep in bf26-core.js */
  var busy = false, t = 0;
  function lone() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      var s = c.querySelectorAll('.color-swatch');
      if (s.length === 1) s[0].classList.add('bf26y-lone');
    });
  }
  /* r55 FX2 (15 Oct 2026, Alexander): guarantee() is removed. It rewrote "30-day money-back guarantee" to the old returns wording after load;
     "30-day money-back guarantee" is the approved wording everywhere and now prints as written. */
  /* r17: pack order */
  function packs() {
    if (!/^\/products\/[^/]*(glove|sock)/i.test(location.pathname) || /claw/i.test(location.pathname)) return;
    document.querySelectorAll('.quantity-breaks-container').forEach(function (c) {
      var pairs = [], kids = Array.prototype.slice.call(c.children);
      kids.forEach(function (k, i) {
        if (k.tagName === 'INPUT' && k.name === 'quantity' && kids[i + 1] && kids[i + 1].tagName === 'LABEL') pairs.push({ i: k, l: kids[i + 1], q: Number(k.value) });
      });
      if (pairs.length < 2) return;
      function rank(q) { return q === 1 ? 0 : q === 3 ? 1 : q === 2 ? 2 : 3 + q; }
      var sorted = pairs.slice().sort(function (a, b) { return rank(a.q) - rank(b.q); });
      var same = sorted.every(function (p, n) { return p === pairs[n]; });
      /* r52f: no DOM reorder. Moving the cards broke Shrine's price refresh on colour change
         (it matches .dynamic-price elements by position, so the 3 Pack price became "Most Popular").
         The 3 Pack now goes first with CSS order in bf26y-r52.css. */
      pairs.forEach(function (p) {
        if (p.q !== 3) return;
        var lab = p.l.querySelector('.quantity-break__label');
        if (lab && !lab.querySelector('.bf26y-bagnote')) {
          var s = document.createElement('span');
          s.className = 'bf26y-bagnote'; s.textContent = '+free wash bag';
          lab.appendChild(s);
        }
      });
    });
  }
  function run() {
    if (busy) return; busy = true;
    try { lone(); } catch (e) {} /* 21 Oct 2026: packs() off, its note was hidden by bf26y-r52.css on every page that had it */
    busy = false;
  }
  function sched() { clearTimeout(t); t = setTimeout(run, 150); }
  function start() { run(); rkLazy(run, function () { new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
